
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"4.306","height":"20.539"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Сгруппировать 28808"}},[_c('path',{attrs:{"data-name":"Typing Copy","d":"M0 18.292a2.2 2.2 0 012.153-2.247 2.249 2.249 0 010 4.494A2.2 2.2 0 010 18.292zm0-8.023a2.2 2.2 0 012.153-2.247 2.249 2.249 0 010 4.494A2.2 2.2 0 010 10.269zm0-8.022A2.2 2.2 0 012.153 0a2.2 2.2 0 012.153 2.247 2.2 2.2 0 01-2.153 2.247A2.2 2.2 0 010 2.247z","fill":"#fff"}})])])
          )
        }
      }
    